import request from "../utils/request";

export async function getQueue(payload) {
  return request.get("UpdateRawMaterialQueue/GetQueue", {
    params: {
      pageIndex: payload.pageIndex,
      status: payload.status ? payload.status.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null
    }
  });
}

export async function cancelUpdate(payload) {
  return request.post("UpdateRawMaterialQueue/CancelUpdate?queueId=" + payload);
}

export async function tryAgainUpdate(payload) {
  return request.post("UpdateRawMaterialQueue/TryAgainUpdate?queueId=" + payload);
}
